import type { Column } from 'react-data-grid';
import { CgInfo } from 'react-icons/cg';
import { Fields, RawData } from '../types';
import { SelectColumn } from 'react-data-grid';

export const generateColumns = <T extends string>(fields: Fields<T>) =>
  fields.map(
    (column: any): Column<any> => ({
      key: column.key,
      name: column.label,
      minWidth: 150,
      headerRenderer: () => (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', position: 'relative', borderColor: 'red', border: 1 }}>
          <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{column.label}</div>
          {column.description && (
            <div style={{ flex:'0 0 auto' }}>
              <CgInfo size="1rem" />
            </div>
          )}
        </div>
      ),
      formatter: ({ row }) => (
        <div style={{ minWidth: '100%', minHeight: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {row[column.key]}
        </div>
      ),
    }),
  );

export const generateSelectionColumns = (data: RawData[]) => {
    const longestRowLength = data.reduce((acc, curr) => (acc > curr.length ? acc : curr.length), 0)
    return [
        SelectColumn,
        ...Array.from(Array(longestRowLength), (_, index) => ({
            key: index.toString(),
            name: '',
        })),
    ]
}
